module.exports = __webpack_public_path__ + "static/media/ic_premium_onboarding.de5c5d3a.svg";